// implements Filter

import {Filter, FilterProps} from "../Filter";
import {html} from "htm/preact";

interface State {
    selected: any[];
}

interface MultiSelectProps extends FilterProps {
    options: any[];
    optionSelection: any;
    onChange?: (filter: Filter) => void
}

export class MultiSelect extends Filter<MultiSelectProps, State> {
    options: any[] = []

    cleared: any = { selected: [] }

    constructor(props: any) {
        super(props);

        this.clear = this.clear.bind(this);

        //sort options alphabetically
        this.options = props.options.sort((a: any, b: any) => a.name.localeCompare(b.name));

        if(this.state.value == null){
            this.setStateValue({selected: []})
        }
        else{
            //for each value in selected add its name to it as that doesn't come through on initial load
            let newStateSelected: any[] = []
            this.state.value.selected.forEach((value: any) => {
                newStateSelected.push({ name: this.getNameForValue(value), value: value})
            });

            this.initialStateValue = {selected: newStateSelected};
            this.setStateValue({selected: newStateSelected})
        }

    }

    render() {
        let selectedValuesHtml;

        if(this.state.value.selected != null || this.state.value.selected != ""){
            selectedValuesHtml = html `                        
        <ul class="govuk-list multiselect-chosen-options">
            ${ 
                this.state.value.selected ?
                    this.state.value.selected.map((option: any) => {
                        return html `
                            <li class="delta-filters_chosen-option">${option.name} <button class="govuk-link govuk-link--no-visited-state delta-filters_remove-option" data-value="${option.value}" onClick=${this.removeOption.bind(this)}></button></li>
                        `
                    }) 
                : ""
            }
        </ul>
        `;
        }

        return html `
            <div class="content">
                <div class="form-group">

                    ${selectedValuesHtml}
                    
                    <div class="multiselect-input-container">
                        <select class="govuk-select multiselect-add delta-filters-select-with-add"  data-placeholder="Select collection">
                            <option value="" disabled selected>Select collection</option>
                            ${this.options.map((option: any) => html `
                            <option value="${option.value}">${option.name}</option>
                        `)}
                        </select>


                        <button class="govuk-button govuk-button--primary" onClick=${this.addOption.bind(this)}>
                            Add
                        </button>
                    </div>
                </div>
            </div>
        `
    }

    getNameForValue(value: string){
        return this.options.find((option: any) => option.value == value)?.name;
    }

    addOption(e: Event) {

        const button = e.target as HTMLSelectElement;
        const select = button.parentElement?.querySelector(".delta-filters-select-with-add") as HTMLSelectElement;
        const option = select.options[select.selectedIndex];

        select.selectedIndex = 0;

        if(this.state.value.selected ){
            const containValue = this.state.value.selected.some(
                (obj: { value: any }) => obj.value === option.value
            );

            if((!containValue || this.state.value.selected.length == 0) && option.value != "" ){
                this.addOptionToState({ name: option.text, value: option.value });
            }
        }
        else if(option.value != ""){
            this.setStateValue({selected: [{name: option.text, value: option.value}]});
        }
    }

    removeOption(e: Event) {
        if(e.target){
            let option = e.target as HTMLElement;
            let optionValue = option.getAttribute("data-value");
            if(optionValue){
                this.removeOptionFromStateByValue(optionValue);
            }
        }
    }

    getQueryParam(): Record<string, string> {
        if(this.state.value && this.state.value?.selected?.length > 0){
            let selectedValues = this.state.value.selected.map((s: any) => s.value);
            let params: { [key: string]: string } = {};

            for(let i = 0; i < selectedValues.length; i++){
                params[this.id + "[" + i + "]"] = selectedValues[i];
            }

            return params;
        }
        return {};
    }
}
